let negativeId: number = -1
export function newId() {
    negativeId = negativeId - 1
    return negativeId
}
